// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3TbD9","footer":"ModalFilter_footer__1_XS-"};